<!-- Page Editor Card -->
<mat-card class="page-editor-card mb-5">
  <mat-card-content>
    <div class="d-flex jcsb">
      <div class="page-templates">
        <h2 class="mb-1">Definierte Seiten</h2>
        <button mat-raised-button (click)="addFirstPage()">add contract info page</button>
        <button mat-raised-button (click)="addSignaturePage()">add signature page</button>
      </div>
      <div class="part-templates">
        <h2 class="mb-1">Definierte Seite Teilen</h2>
        <mat-form-field appearance="outline" class="mr-2">
          <mat-label>Header</mat-label>
          <mat-select name="header" (selectionChange)="addHeader($event)" >
            @for (header of headers; track header) {
              <mat-option [value]="header.value">{{header.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" >
          <mat-label>Footer</mat-label>
          <mat-select name="footer" (selectionChange)="addFooter($event)" >
            @for (footer of footers; track footer) {
              <mat-option [value]="footer.value">{{footer.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <hr>
    </div>
    <form [formGroup]="pageForm">
  <div class="header-preview mt-2 mb-2" [innerHtml]="currentHeader"></div>
      <div class="editor-container">
        <label class="editor-label mb-2">Seiteninhalt</label>
        <!--          <div #editorContainer class="editor" formControlName="content"></div>-->

        <!--        <div class="NgxEditor__Wrapper editor">-->
        <!--          <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>-->
        <!--          <ngx-editor [editor]="editor" [ngModel]="html" [placeholder]="'Type here...'" formControlName="content"></ngx-editor>-->
        <!--        </div>-->
        <editor
          [init]="editorConfig"
          formControlName="content"
          [disabled]="false"
          licenseKey="gpl">
        </editor>
        @if (pageForm.get('content')?.hasError('required') && pageForm.get('content')?.touched) {
          <mat-error class="editor-error">Inhalt ist erforderlich</mat-error>
        }
      </div>
      <input type="hidden" formControlName="pageId"/>
    </form>
    <div class="header-preview" [innerHtml]="currentFooter"></div>
  </mat-card-content>

  <mat-card-actions>
    <button
      type="button"
      (click)="onPageSubmit()"
      mat-raised-button
      color="primary"
      [disabled]="!pageForm.valid || pageForm.untouched">
      <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
      Seite speichern
    </button>
    <button
      type="button"
      (click)="addPage()"
      mat-raised-button>
      <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
      Neue Seite
    </button>
  </mat-card-actions>
</mat-card>

<!-- Pages Preview Card -->
@if (pages.length > 0) {
  <mat-card class="pages-preview-card">
    <mat-card-header>
      <mat-card-title>
        <mat-icon fontSet="material-symbols-outlined">pages</mat-icon>
        Seiten ({{ pages.length }})
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div cdkDropList class="pages-grid" (cdkDropListDropped)="drop($event)">
        @for (page of pages; track page.sort; let i = $index) {
          <div class="page-preview" cdkDrag>
            <div class="actions">
              <button matIconButton (click)="editPage(page)">
                <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
              </button>
              <button matIconButton (click)="deletePage(page.id)">
                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
            <div class="page-header">
              <img src="phoenix-logo-corp.svg" alt="Phoenix Logo" class="page-logo">
            </div>
            <div class="page-content" [innerHTML]="page.body_html"></div>
            <div class="page-footer">
              <span class="page-number">Seite {{ i + 1 }}</span>
            </div>
            <!--            <div class="preview-hover" (click)="preview(page)">-->
            <!--              <button matIconButton ><mat-icon fontSet="material-symbols-outlined">visibility</mat-icon></button>-->
            <!--            </div>-->
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
}
